import { Controller } from 'stimulus';
import init from '../dashkit/js/functions/select2';

export default class extends Controller {
  connect() {
    init(this.element);
  }
}
